import { saveToStorage } from "../../Components/Functions";
import Api from "../../Server/Api";
import { UPDATE } from "./types";

const api = new Api();

export const bookSpecialist = (data = {}, callback) => {
	return async (dispatch) => {
		dispatch({ ...data, type: UPDATE, booking: true })
		const res = await api.post({ endpoint: "/appointments/", data });
		callback && callback(res);
		dispatch({ ...data, type: UPDATE, booking: false, result: res })
	}
};

export const checkAvailableDates = (data = {}, callback) => {
	return async (dispatch, getState) => {
		dispatch({ type: UPDATE, checking: true })
		const profile = getState().specialist?.profile;
		const res = await api.post({ endpoint: "/users/"+profile?.username+"/available_dates/", data });
		dispatch({ ...getState().booking, available_dates: res, type: UPDATE, checking: false })
		callback && callback(res);
	}
};

export const updateBooking = (data = {}) => {
	const store = { ...data, type: UPDATE }; 
	saveToStorage({ name: UPDATE, value: store })
	return store;
};
